import { withInstall } from '@antdv/utils';
import AProgress from './src/Progress';

export const Progress = withInstall(AProgress);

export default Progress;

export * from './src/interface';
export * from './src/props';
